import React from 'react'

export const Input = (props) => {
  let type = props.type || 'text'
  return (
    <input class="gray-text-field login w-input" type={type} {...props}/>
  )
}

export const Submit = (props) => {
  return (
    <input type="submit" class="link-color-button contact w-button" {...props}/>
  )
}

export const Link = (props) => {
  return (
    <a href="javascript: void(0);" class="login-link" onClick={props.onClick}>{props.children}</a>
  )
}

export const SuccessMsg = (props) => {
  return (
    <div class="sucess-mesage w-form-done" style={{display: 'block', color: '#fff'}}>
      <div>{props.children}</div>
    </div>
  )
}

export const ErrorMsg = (props) => {
  return (
    <div class="error-message w-form-fail" style={{display: 'block', color: '#fff'}} >
      <div>{props.children}</div>
    </div>
  )
}

export const Intro = (props) => {
  return (
    <p class="intro-paragraph" {...props}>{props.children}</p>
  )
}
